import { defaultProps } from 'recompose';
import Tags from '../../app/components/tags';

export default defaultProps({
  w: '65%',
  mt: -2,
  mb: 4,
})(Tags);



// WEBPACK FOOTER //
// ./src/Details/tags/index.js